import React from "react";
import Button from "../components/Button";

export default function ValoracionNutricional() {

  // ✅ Función para abrir un PDF en una nueva pestaña
  const abrirPDF = (nombreArchivo) => {
    const url = `/docs/${nombreArchivo}`;
    window.open(url, "_blank");
  };

  return (
    <div className="p-4 max-w-xl mx-auto flex flex-col gap-4">
      {/* Encabezado */}
      <div className="flex items-center justify-center">
        <h3 className="font-bold text-center">VALORACIÓN NUTRICIONAL</h3>
      </div>

      {/* Introducción */}
      <div className="text-justify">
        <p className="mb-2">
          Debe seleccionar el cribado óptimo para su paciente, según su situación y/o ámbito sanitario.
        </p>
        <p className="mb-2">
          Si en el cribado obtiene una puntuación positiva o de riesgo, debe realizar una valoración y diagnóstico nutricional.
        </p>
        <p>
          A continuación, puede abrir los documentos en formato PDF para su consulta o impresión.
        </p>
      </div>

      {/* Cribado nutricional */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <h4 className="font-bold mb-3 text-center">Cribado nutricional</h4>

      {/* Bloque de PDFs */}
      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => abrirPDF("mna_descargable.pdf")}>
          Paciente mayor de 65 años (MNA®)
        </Button>

        <Button onClick={() => abrirPDF("mst_descargable.pdf")}>
          Paciente con cáncer (MST)
        </Button>

        <Button onClick={() => abrirPDF("nrs_descargable.pdf")}>
          Paciente hospitalizado (NRS-2002)
        </Button>

        <Button onClick={() => abrirPDF("must_descargable.pdf")}>
          Paciente ambulatorio (MUST)
        </Button>
      </div>
      </div>

      {/* Valoración y diagnóstico nutricional */}
      <div className="bg-white border rounded-lg p-4 leading-relaxed text-justify">
        <h4 className="font-bold mb-3 text-center">Valoración y diagnóstico nutricional</h4>

      {/* Bloque de PDFs */}
      <div className="flex flex-col gap-4 mt-2 font-semibold text-white">
        <Button onClick={() => abrirPDF("glim_descargable.pdf")}>
          Criterios GLIM
        </Button>
      </div>
      </div>
    </div>
  );
}